<template>
	<div class="l-full--tb128 l-full--tb256l module c-hero-title" data-parallax-wrap>
		<div class="t-h--13 t-h--11s c-hero-title__capt i--label-wrap">
			<span class="t--fak"><span class="t--ft">(</span><span class="i--label">{{ data.target.label }}</span><span class="t--ft">)</span></span>
		</div>
		<div class="c-hero-title__item-wrap">
			<div class="i--center">
				<div class="t-h--128 t-h--200l t-h--54s c-hero-title__item c-hero-title__item--1" data-parallax="1" data-direction="right">
					<span class="t--fak">{{ data.target.center }}</span>
				</div>
			</div>
			<div class="i--left">
				<div class="t-h--128 t-h--200l t-h--54s c-hero-title__item c-hero-title__item--2" data-parallax="3" data-direction="right">
					<span class="t--fak">{{ data.target.left }}</span>
				</div>
			</div>
			<div class="i--right">
				<div class="t-h--128 t-h--200l t-h--54s c-hero-title__item c-hero-title__item--3" data-parallax="3" data-direction="left">
					<span class="t--fak">{{ data.target.right }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as _ from "fxjs";
import { computed, ref, reactive, useStore } from "@/helper/vue.js";
import Picture from "@/parts/picture/PictureView.vue";

export default {
  props: ["idx", "bindRoot"],
	components: {
		Picture
	},
  setup(props) {
    const { get } = useStore();
		const self = ref();
		const data = reactive({
			target: computed(() => get["from"](`${props.bindRoot}.modules.${props.idx}`)),
		});

    return {
			self,
			data,
    };
  },
};
</script>